 window.PubSub = (() => {
  const subscribers = {};

  function subscribe(eventName, callback) {
    if (!subscribers[eventName]) {
      subscribers[eventName] = [];
    }

    subscribers[eventName].push(callback);

    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter(
        cb => cb !== callback
      );
    };
  }

  function publish(eventName, data = {}) {
    if (!subscribers[eventName]) return;

    subscribers[eventName].forEach(callback => {
      try {
        callback(data);
      } catch (e) {
        console.error(`PubSub error in "${eventName}"`, e);
      }
    });
  }

  return {
    subscribe,
    publish
  };
})();

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  variantChange: 'variant-change',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change'
};

window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
